import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { RestService } from 'src/app/services/rest-service';
import { AppSettings } from 'src/app/shared/app-settings';
import { GridOptions } from 'ag-grid-community';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EditDeleteRendererComponent } from '../../components/edit-delete-renderer/edit-delete-renderer.component';
import { ConfirmationDialogueComponent } from '../../components/confirmation-dialogue/confirmation-dialogue.component';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-privilege',
  templateUrl: './privilege.component.html',
  styleUrls: ['./privilege.component.css']
,
  standalone: false
})
export class PrivilegeComponent implements OnInit {
  privilegesList: any = [];
  gridOptions: GridOptions;
  // gridOptions = {
  //   defaultColDef: {},
  //   columnDefs: [],
  //   rowData: [],
  //   api: ''
  // };
  columnDefs: any;
  rowData: any;
  defaultColDef: any;
  domLayout = '';
  privilegeName: any = '';
  modalRef: NgbModalRef;
  action = '';
  pvOldName : any;
  pvNewName : any;
  privilegeId: any;
  popupHeading;
  @ViewChild('addPrivilege', { static: false }) adprivilege: ElementRef<any>;
  currentUser: any = null;
  oldPV: any;
  constructor(
    private titleService: Title,
    public restService: RestService,
    private ngbModalService: NgbModal,
    private modalService: NgbModal, public spinner: SpinnerService,
    private toastr: ToastrService) {
      this.titleService.setTitle("Privilege");
    this.domLayout = "autoHeight"
    this.currentUser = localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : null;
  }

  ngOnInit(): void {
    this.getPrivileges();
    // this.popupHeading = (this.action == 'add')?'Add Privilege': 'Edit Privilege'
    let title = this.titleService.getTitle();
  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }

  getPrivileges() {
    this.spinner.activate();
    this.privilegesList = [];
    this.restService.getRequest(AppSettings.GETPRIVILEGE).subscribe({
      next: (response) => {
        const pList = Array.isArray(response?.data) ? response.data : [];
        pList.forEach(privilege => {
          this.privilegesList.push({
            id: privilege.id,
            name: privilege.name
          });
        });
        this.gridOptions = {
          defaultColDef: {
            resizable: true,
            sortable: true,
            filter: true,
            headerClass: 'headerClass'
          },
          columnDefs: [
            { headerName: 'Privilige Name', field: 'name' },
            {
              headerName: 'Action', field: 'action', cellRenderer: EditDeleteRendererComponent,
              cellRendererParams: {
                onEditClick: this.onEditClick.bind(this),
                onDeleteClick: this.onDeleteClick.bind(this),
                showPrivilegeEdit: true
              }
            }
          ],
          rowData: this.privilegesList,
        };
      },
      error: (err) => {
        if (err.error?.message?.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      },
      complete: () => this.spinner.deactivate()
    });
  }

  onAddClick() {
    this.action = 'add';
    this.privilegeName = '';
    this.popupHeading = 'Add Privilege'
    this.modalRef = this.ngbModalService.open(this.adprivilege);
  }

  onEditClick(id) {
    this.action = 'edit';
    this.popupHeading = 'Edit Privilege';
    let item = this.privilegesList.find(item => item.id === id);    
    this.privilegeName = item.name;
    this.privilegeId = item.id;
    this.modalRef = this.ngbModalService.open(this.adprivilege);
    this.oldPV =  this.privilegeName 
  }

  savePrivilege() {
    if (this.privilegeName.length > 0) {
      if (this.privilegeName.length < 51) {
        if (this.action == 'add') {
          let model = {
            name: this.privilegeName
          }
          this.spinner.activate();
          this.restService.postRequest(AppSettings.ADDPRIVILEGE, model).subscribe((response: any) => {
            if (response.success) {
              this.privilegeName = '';
              this.modalService.dismissAll();
              // this.adprivilege.nativeElement.click();
              this.toastr.success('Privilege added successfully', 'Success');
              this.getPrivileges();              
            }
            this.spinner.deactivate();
          }, (err) => {
            this.spinner.deactivate();
            if (err.error.message.length > 0) {
              this.toastr.error(err.error.message, 'Error');
            } else {
              this.toastr.error('Session Expired Please login again.', 'Error');
            }
          })
          this.modalService.dismissAll();
        }
        if (this.action == 'edit') {
          let pvNewName = this.privilegeName
          if(pvNewName === this.oldPV){
            this.toastr.error('You have not changed anything', 'Error');
           this.modalService.dismissAll();
           this.getPrivileges();
          }
          let model = {
            id: this.privilegeId,
            name: this.privilegeName
          }
          this.spinner.activate();
          this.restService.putRequest(AppSettings.EDITPRIVILIGES, model).subscribe((response: any) => {
            if (response.success) {
              this.privilegeName = '';
              this.modalService.dismissAll();
              this.toastr.success('Privilege updated successfully', 'Success');
              this.getPrivileges();
              this.spinner.deactivate();
            }
          }, (err) => {
            this.spinner.deactivate();
            if (err.error.message.length > 0) {
              this.toastr.error(err.error.message, 'Error');
            } else {
              this.toastr.error('Session Expired Please login again.', 'Error');
            }
          })
        }
      }
      else {
        // this.toastr.error('Privilege name should not be more than 50 characters.', 'Error');
      }
    }
    else {
      // this.toastr.error('Privilege name should not be more than 50 characters.', 'Error');
    }

  }

  onDeleteClick(id) {

    let popupData = {
      title: "Delete Confirmation",
      message: "Are you sure you want to delete this item?",
      cancelBtnText: "No",
      confirmBtnText: "Confirm"
    }
    let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialoge.componentInstance._data = popupData;
    dialoge.result.then(data => {
      if (data) {
        this.spinner.activate();
        this.restService.deleteprevilege(AppSettings.DELETEPRIVILIGES, id).subscribe((response: any) => {
          if (response) {
            this.toastr.success('Privilege deleted successfully', 'Success');
            this.getPrivileges();
          }
          this.spinner.deactivate();
        }, (err) => {
          this.spinner.deactivate();
          if (err.error.message.length > 0) {
            this.toastr.error(err.error.message, 'Error');
          } else {
            this.toastr.error('Session Expired Please login again.', 'Error');
          }
        })
      }
    });
  }  

}
